"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
const sitecore_jss_react_1 = require("@sitecore-jss/sitecore-jss-react");
/**
 * Context instance that is used to initialize the application Context and associated Software Development Kits (SDKs).
 */
class Context {
    constructor(props) {
        this.props = props;
        /**
         * Indicates whether the Context and SDK(s) have been initialized
         */
        this.isInitialized = false;
        /**
         * Software Development Kits (SDKs) to be initialized
         */
        this.sdks = {};
        /**
         * Promises for the SDKs
         */
        this.sdkPromises = {};
        this.sdkErrors = {};
        /**
         * Retrieves the Software Development Kit (SDK) instance, ensuring it is initialized before returning
         *
         * @param {string} name SDK name
         * @returns initialized SDK
         */
        this.getSDK = (name) => {
            if (!this.sdkPromises[name]) {
                return Promise.reject(`Unknown SDK '${String(name)}'`);
            }
            else {
                return this.sdkPromises[name].then((result) => {
                    return ((this.sdkErrors[name] && Promise.reject(this.sdkErrors[name])) || Promise.resolve(result));
                });
            }
        };
        this.sitecoreEdgeUrl = props.sitecoreEdgeUrl;
        this.sitecoreEdgeContextId = props.sitecoreEdgeContextId;
        this.siteName = props.siteName;
        this.pageState = sitecore_jss_react_1.LayoutServicePageState.Normal;
    }
    init(props = {}) {
        // Context and SDKs are initialized only once
        if (this.isInitialized)
            return;
        this.isInitialized = true;
        if (props.siteName) {
            this.siteName = props.siteName;
        }
        if (props.pageState) {
            this.pageState = props.pageState;
        }
        // iterate over the SDKs and initialize them
        for (const sdkName of Object.keys(this.props.sdks)) {
            this.initSDK(sdkName);
        }
    }
    /**
     * Initializes the Software Development Kit (SDK)
     *
     * @param {T} name SDK name
     * @returns {void}
     */
    initSDK(name) {
        this.sdkPromises[name] = new Promise((resolve) => {
            this.props.sdks[name]
                .init(this)
                .then(() => {
                this.sdks[name] = this.props.sdks[name].sdk;
                resolve(this.sdks[name]);
            })
                .catch((e) => {
                // if init rejects, we mark SDK as failed - so getSDK call would reject with a reason
                this.sdkErrors[name] = e;
                resolve(undefined);
            });
        });
    }
}
exports.Context = Context;
